export default __webpack_public_path__ + "static/media/0xbbe47167666100eC33de9079c1EE7B150cCbD874.7bd1c8d6.svg";